import { ListingEditorIndexPage } from "@/components/listing-editor";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/supplier/$supplierId/listings/$listingId/$version/")({
  component: Page,
});

function Page() {
  const { listingId, version } = Route.useParams();
  return <ListingEditorIndexPage listingId={listingId} version={version} />;
}
